import React, { useContext } from 'react';
import i18next from 'i18next';
import { Textlink } from '../../../../AutostadtTabComponents/Button';
import SubpageBlue from '../../SubpageBlue';
import './styles.scss';
import Textbox from '../../../../AutostadtTabComponents/Tiles/Textbox';
import { setASSubpage } from '../../../../../utils/SspProvider/dispatchFunctions';
import { ASSubpageEnum } from '../../../../../enums';
import SspProviderContext from '../../../../../utils/SspProvider/context';

export default function Delay() {
    const store = useContext(SspProviderContext);

    return (
        <SubpageBlue
            title={i18next.t('DelayTitle')}
            className='delay'
            headerChildren={<p className='body large'>{i18next.t('DelaySubline')}</p>}
        >
            <>
                <Textbox
                    headline={i18next.t('DelayIndicatorHeadline')}
                    text={i18next.t('DelayIndicatorText')}
                    buttonText={i18next.t('DelayIndicatorBtn')}
                    color='white'
                    onClick={() => {
                        window.open(`https://www.autostadt.de/formular-verspaetungsinformation?vin=${new URLSearchParams(location.search).get('vin')}`, '_blank', 'noopener,noreferrer');
                    }}
                />
                <Textbox
                    headline={i18next.t('ArrivalOutsideOpeningHoursHeadline')}
                    text={i18next.t('ArrivalOutsideOpeningHoursText')}
                    buttonText={i18next.t('ArrivalOutsideOpeningHoursBtn')}
                    color='neon'
                    svg='as-info'
                    onClick={() => {
                        setASSubpage(store, {
                            asEnum: ASSubpageEnum.OpeningHours,
                        });
                    }}
                />
                <div className='container-reach-by-phone'>
                    <h3>{i18next.t('PhoneReachabilityHeadline')}</h3>
                    <p className='body large'>{i18next.t('PhoneReachabilityText')}</p>
                    <Textlink
                        type={'svg-left'}
                        color={'white'}
                        text={i18next.t('PhoneNumber')}
                        svg='#as-phone'
                        onClick={() => {
                            const numberWithoutSpaces = i18next.t('PhoneNumber').replace(/\s+/g, '');
                            window.location.href = `tel:${numberWithoutSpaces}`;
                        }}
                    />
                </div>
            </>
        </SubpageBlue>
    );
}
